import React, {FC, useEffect, useRef, useState} from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, useMenuIdPermissions } from '../../../reusable'
import {PageTitle} from '../../../_metronic/layout/core'

import {
  MixedWidget23
} from '../../../_metronic/partials/widgets/mixed/MixedWidget23'
import { TourPackageDetailsHeader } from './TourPackageDetailsHeader'
import Swal from 'sweetalert2'
import { Tr } from '../../../_metronic/i18n/Tr'

const ViewToursList: FC = () => {
  let t = Tr()
  const location = useLocation();
  const edittourpackageId = (location.state as any)?.tourpackageId || '';
      const {menuId , menuIdDelete} = useMenuIdPermissions()


    // -------- state start ------------ 
  const [editToursId,setEditToursId] = useState("");
  const [tourDetails, setTourDetails] = useState([]);
  const [primLanguage, setPrimLanguage] = useState("");

  const [offset,setoffset]=useState(0)
  const [limit,setlimit]=useState(9);
  const [page,setpage]=useState(1)
  const [totalPage,setTotalPage]=useState(1)
  const [from,setfrom]=useState(1)
  const [to,setTo]=useState(1)
  const [displaytourList, setDisplaytourList] = useState([]);
  const [pageNumbersList,setPageNumberList]=useState([1])
  // ----------- state end ------------
    
  // ----------------------- functions ---------------------------- 
  // page number generater
  function generatePageNumbers(currentPage:any, totalPages:any, maxPagesToShow:any) {
      const halfMaxPages = Math.floor(maxPagesToShow / 2);
      let startPage = Math.max(1, currentPage - halfMaxPages);
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
      if (endPage - startPage + 1 < maxPagesToShow) {
          startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      // Generate the list of page numbers
      const pageNumbers = [];
      for (let i = startPage; i <= endPage; i++) {
          pageNumbers.push(i);
      }

      return pageNumbers;
  }
  // on page change function
  const onPageChange=(pageId:any)=>{
    if(pageId!=page && pageId!=0 && pageId<=totalPage)
    {
      var tmp=(pageId-1)*limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp+1)
      // setto
      var mod=tourDetails.length%limit
      var tolimi:any=limit
      if(mod>0)
      {
        if(mod<=limit)
        {
          tolimi=pageId*limit
          
        }
        else
        {
          tolimi=pageId*limit+limit
        }
      }
      else
      {
        tolimi=pageId*limit
      }
      setTo(tolimi)
      var tmpdata:any=tourDetails.slice(tmp,tolimi)
      setDisplaytourList(tmpdata)
    }

  }



  // ------------------------------------- apis call ------------------------------------
  // space Details api call
  const toursDetailsApiCall=async()=>{
        
    var param: any = {
      tourpackageId:String(edittourpackageId),
    }
    var response: any = await fetchData('vendor/public/tourpackageDetails', param)
    
    if(response.status=="200")
    {
        var tourList = response.data[0]['toursDetail']
     
        setTourDetails(tourList);
        setPrimLanguage(response.data[0]['primaryLanguage'])
        var tmp:any=tourList.slice(offset, offset+limit);
        setDisplaytourList(tmp)
        var totpag=(Math.ceil(tourList.length/limit))
        setTotalPage(totpag)
        if(totpag==1)
        {
          var mod=tourList.length%limit
          if(mod>0)
          {
            setTo(mod)
          }
          else
          {
            setTo(tmp.length)
          }
        }
        else
        {
          var mod=tourList.length%limit
          if(mod>0)
          {
            setTo(page*limit+mod)
          }
          else
          {
            setTo(page*limit)
          }
        }
        var genpag=generatePageNumbers(page,totpag,6)
        setPageNumberList(genpag)
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  //   delete rentable space api call
  const confirmdelete = (rentablespaceId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'rentablespaceId': rentablespaceId
        }
        var res = await fetchData("vendor/public/deleteRentableSpace", param)

        if (res.status == "200") {
          toursDetailsApiCall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }

  useEffect(()=>{
    toursDetailsApiCall();
  },[editToursId])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("View Tours List")}</PageTitle>
      <ToastContainer />
      <TourPackageDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {  displaytourList.map((tour: any, index: any) => {

          var maxPeople = tour["maxPeople"]

          var tourType= ""
          tour["tourTypeDetails"].map((item :any )=> {
            tourType = item['en_name'] 
          })
          var tourName = ''
          if (primLanguage == 'English') {
            tourName = tour['en_name']
          } else if (primLanguage == 'Russian') {
            tourName = tour['ru_name']
          } else if (primLanguage == 'Uzbek') {
            tourName = tour['uz_name']
          }
          return (
            <div className='col-xl-4' key={index}>
              <MixedWidget23
                className='card-xl-stretch mb-5 mb-xl-8'
                color='success'
                toursId={tour['toursId']}
                deleteTour={confirmdelete}
                tourName={tourName}
                image={
                  tour['images'].length != 0
                    ? tour['images'][0].thumbPath
                    : '/horse/uztrip/vendor/media/logos/uztripLogo.png'
                }
                maxPeople={maxPeople}
                progress='100%'
                tourType ={tourType}
                showDelete={menuIdDelete}
                menuId={menuId}
                
              />
            </div>
          )
        })}
      </div>
      {tourDetails.length != 0 ? (
        <>
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>
              Showing {from} to {to} of {tourDetails.length} entries
            </div>

            <ul className='pagination'>
              <li className={`page-item previous ${page > 1 ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page > 1 ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => onPageChange(page - 1)}
                >
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any) => {
                return (
                  <li className={`page-item cursor-pointer ${page == item ? 'active' : ''}`}>
                    <span className='page-link' onClick={() => onPageChange(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? '' : 'disabled'}`}>
                <span
                  className={`page-link ${page + 1 <= totalPage ? 'cursor-pointer' : 'disabled'}`}
                  onClick={() => (page + 1 <= totalPage ? onPageChange(page + 1) : '')}
                >
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        </>
      ) : (
        ''
      )}
      {/* end::Row */}
    </>
  )
}

export {ViewToursList}
